var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4351",
    "data-name": "Group 4351",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.242,
    height: 29.728,
    viewBox: "0 0 75.242 29.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phonepe-logo-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M14.877,29.728a14.946,14.946,0,0,1-3.429-.4,14.786,14.786,0,0,1-7.5-4.38,14.911,14.911,0,0,1-3.737-7.6A14.869,14.869,0,0,1,14.852,0a14.936,14.936,0,0,1,3.427.4,14.793,14.793,0,0,1,7.5,4.38,14.907,14.907,0,0,1,3.737,7.6A14.869,14.869,0,0,1,14.877,29.728h0ZM16.3,20.615h0v2.662a1.317,1.317,0,0,0,.384.944,1.3,1.3,0,0,0,.928.384H18.79a.54.54,0,0,0,.5-.5V12.232h1.928a.394.394,0,0,0,.392-.417v-.829A1.1,1.1,0,0,0,20.53,9.92H18.536L13.97,4.676a1.694,1.694,0,0,0-1.745-.5l-1.582.5a.368.368,0,0,0-.167.581L15.463,9.99H7.891a.387.387,0,0,0-.278.116.4.4,0,0,0-.115.3v.83a1.1,1.1,0,0,0,1.08,1.079H9.741V16.3c0,2.964,1.583,4.733,4.234,4.733l.171,0a5.693,5.693,0,0,0,2.154-.419Zm-1.6-2.157h-.073a1.943,1.943,0,0,1-1.494-.518,2.3,2.3,0,0,1-.5-1.64V12.314h3.653v5.812A3.942,3.942,0,0,1,14.7,18.458Z",
    fill: "#474747"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "PhonePe",
    transform: "translate(32.242 17.392)",
    fill: "#474747",
    fontSize: 10,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PhonePe"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepay);
export default __webpack_public_path__ + "static/media/phonepay.182750b9026c7e6df7c7aeae94319445.svg";
export { ForwardRef as ReactComponent };